import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {Button} from 'reactstrap';
import {connect} from 'react-redux';
import {FMessage} from '../../hoc/IntlComponents';
import {bool, number} from 'prop-types';
import Card from '../../components/Card/Card';
import Hint from '../../components/Hint/Hint';
import {getContestUrl} from '../../utils/utils';
import OFFChecksCashedModal from "../../modals/OFFChecksCashedModal/OFFChecksCashedModal";
import OFFChecksOkModal from "../../modals/OFFChecksCashedModal/OFFChecksOkModal";
import { cash, party } from "../../services/ApiService";
import { useHistory } from 'react-router';


const propTypes = {
  total: number,
  offchecks: number,
  cashed: number,
  position: number,
  slave: bool,
  team: bool,
  // cashing: bool,
};

const defaultProps = {
  total: 0,
  offchecks: 0,
  cashed: 0,
  position: null,
  slave: false,
  team: false,
  // cashing: false,
};

const OffChecksContestWidget = ({
  total,
  offchecks,
  cashed,
  /*cashing,*/
  position,
  slave,
  team,
  collapsing,
  localStorageName,
  canOrderTicket,
  meetupTicketId,
}) => {
  const history = useHistory();
  const cashing = false;
  let type;
  let nowCashed = 0;

  const [isOpen, setOpenModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isOkOpen, setOpenOkModal] = useState(false);

  const [err, setError] = useState('');
  const [checks, setChecks] = useState(offchecks);
  const [cashedChecks, setCashedChecks] = useState(cashed);

  const [nowCashedChecks, setNowCashedChecks] = useState(0);
  const [endOpt, setEndOpt] = useState(1);
  const [ticket, setTicket] = useState(false);




  if (!team) {
    type = 'personal';
  } else if (slave) {
    type = 'slave';
  } else {
    type = 'master';
  }


  const sendData = data => {
    setLoading(true);
    cash.fetchData(data)
      .then(response => {
        setOpenModal(false);
        setLoading(false);
        nowCashed = response.data.items.cashed;
        setNowCashedChecks(nowCashed);
        setChecks(checks - nowCashed);
        setCashedChecks(cashedChecks + nowCashed);
        setEndOpt(chooseEndOpt());
        setTicket(response.data.items.ticket);
        setOpenOkModal(true);
      })
      .catch(error => {
        setLoading(false);
        if (error == 'Error: Network Error') {
          setError('Ошибка сети. Пожалуйста, проверьте соединение с Интернетом и попробуйте ещё раз.');
        } else {
          setError(error.response.data.error.message.message);
        }
      })
  }

  const redirectToPartyTicket = (ticketId) => {
    history.push(`/tickets/${ticketId}`)
  }

  const sendPartyTicketRequest = () => {
    party
      .requestTicket()
      .then(resp => {
        const ticketId = resp.data.items.length && resp.data.items[0].ticket?.id;
        if(ticketId) {
          redirectToPartyTicket(ticketId);
        }
      })
      .catch(error => setError(error.response.data.error.message.message));
  }

  const chooseEndOpt = () => {
    if (nowCashed > 5 && nowCashed < 21) {
      return 1;
    } else {
      const lastDigital = nowCashed % 10;
      if (lastDigital == 1) {return 3;}
      if (lastDigital < 5) {return 2}
      return 1;
    }
  }

  const handleRedeemButtonClick = () => {
    if (canOrderTicket) {
      return sendPartyTicketRequest();
    }
    if (meetupTicketId) {
      return redirectToPartyTicket(meetupTicketId);
    }
    if (!slave && cashing) {
      setOpenModal(true)
    }
  }

  return (
    <Card className="off-checks-widget" localStorageName={localStorageName} collapsing={collapsing}>
      <div className="off-checks-container">
        <Card.Header>
          <FormattedMessage id="widgets.off-checks.title" defaultMessage="OFFERRUM Grand-Prix"/>
        </Card.Header>
        <Card.Body className="no-padding">
          <div className="oc-panel">
            <span className="oc-panel__item">
              <span className="oc-panel__title">
                <FMessage id="widgets.off-checks.position"/>
              </span>
              <span className="oc-panel__value">
                {slave
                  ? <span>-- </span>
                  : <span>
                      {position || '>50'}
                      <FormattedMessage id="widgets.off-checks.position-text" defaultMessage=" place"/>
                    </span>
                }
                <span>
                  <Hint
                    id={`${type}-position-tooltip`}
                    text={
                      <FormattedMessage
                        id={`widgets.off-checks.${type}.position.hint`}
                        defaultMessage="Your position in the rating is taken into account in the sum with all OFF checks of the whole team. Your subordinates are not counted in the ranking of the contest."
                      />
                    }
                  />
                </span>
              </span>
            </span>

            <span className="oc-panel__item">
              <span className="oc-panel__title">
                <FMessage id="widgets.off-checks.balance"/>
              </span>
              <span className="oc-panel__value">
                {checks}
                <Hint
                  id="offchecks-count-tooltip"
                  text={
                    <FormattedMessage
                      id={`widgets.off-checks.${type}.hint`}
                      defaultMessage="One OFF-check is issued for every 5000 rubles, 50 dollars or 50 euros earned. Currency is not cumulative."
                    />
                  }
                />
              </span>
            </span>

            {team && !slave && <span className="oc-panel__item">
                <span className="oc-panel__title">
                  <FMessage id="widgets.off-checks.total"/>
                </span>
                <span className="oc-panel__value">
                  {total}
                  <Hint
                    id="all-team-position-tooltip"
                    text={
                      <FormattedMessage
                        id="widgets.off-checks.team.balance.hint"
                        defaultMessage="The overall balance of the team, including personal OFF checks. Your subordinates cannot cash OFF checks, only you can do it."
                      />
                    }
                  />
                </span>
              </span>
            }

            <span className="oc-panel__item">
              <span className="oc-panel__title">
                <FMessage id="widgets.off-checks.cashed"/>
              </span>
              <span className="oc-panel__value">
                {cashedChecks}
                <Hint
                  id="offchecks-cashed-tooltip"
                  text={
                    <FormattedMessage
                      id={`widgets.off-checks.cashed.hint`}
                      defaultMessage="OFF-checks cashed"
                    />
                  }
                />
              </span>
            </span>

          </div>
        </Card.Body>

        <Card.Footer className="no-padding">
          <div className="off-checks-links">
            <span className="hint-button">
              <Button
                color="outline-primary"
                size="sm"
                className={`off-checks-redeem-button ${
                  !canOrderTicket && !meetupTicketId ? 'disabled' : ''
                }`}
                onClick={handleRedeemButtonClick}
              >
                {canOrderTicket || meetupTicketId ? (
                  <FormattedMessage
                    id="widgets.off-checks.btn.get-ticket"
                    defaultMessage="Get Party ticket"
                  />
                ) : (
                  <FormattedMessage
                    id="widgets.off-checks.btn.cash-out"
                    defaultMessage="Cash out"
                  />
                )}
              </Button>
              {slave &&
              <Hint
                id="slave-cash-out-tooltip"
                text={
                  <FormattedMessage
                    id={`widgets.off-checks.slave.cash-out.hint`}
                    defaultMessage="OFF checks can only be cashed by a master account"
                  />
                }
              />
              }
              {!slave && !cashing &&
              <Hint
                id="second-cash-out-tooltip"
                text={
                  <FormattedMessage
                    id={`widgets.off-checks.personal.cash-out.hint`}
                    defaultMessage="Cashing of OFF-checks for participation in the second stage prize draw will start on 05.10.2021"
                  />
                }
              />
              }
            </span>
            <a
              role="button"
              className="btn btn-primary no-focus"
              href={getContestUrl()}
              target="_blank"
            >
              <FMessage id="widgets.off-checks.btn.about"/>
            </a>
          </div>
        </Card.Footer>
      </div>
      <OFFChecksCashedModal
        isOpen={isOpen}
        error={err}
        toggleModal={() => {setOpenModal(false); setError('')}}
        sendData={sendData}
        isLoading={isLoading}
      />
      <OFFChecksOkModal
        isOpen={isOkOpen}
        toggleModal={() => setOpenOkModal(false)}
        cashed={nowCashedChecks}
        endOpt={endOpt}
        ticket={ticket}
      />
    </Card>
  );
};

OffChecksContestWidget.propTypes = propTypes;
OffChecksContestWidget.defaultProps = defaultProps;

const mapStateToProps = state => ({
  total: state.webmaster.profile.offchecks.total,
  position: state.webmaster.profile.offchecks.position,
  offchecks: state.webmaster.profile.offchecks.count,
  cashed: state.webmaster.profile.offchecks.cashed,
  team: state.webmaster.profile.offchecks.team,
  slave: !!state.webmaster.profile.master.slave,
  canOrderTicket: state.webmaster.profile.offchecks.could_make_meetup_ticket,
  meetupTicketId: state.webmaster.profile.offchecks.meetup_ticket_id,
  // cashing: state.webmaster.profile.offchecks.cashing,
});

export default connect(mapStateToProps)(OffChecksContestWidget);
